<template>
  <div
    class="schedule-panel shadow"
    @click="$emit('to-order-detail', data)"
  >
    <van-row
      gutter="10"
      v-if="orderType == 11007"
    >
      <!--    酒店部分-->
      <div class="Hotel">
        <div class="kh-ho">
          <span>
            <span class="business_icon_style">
              <img src="../../../images/home/cx2.png" style="width: 22px;height: 16px">
            </span>&nbsp;
            <span>{{ data.voyageZh }}·</span>
            <span>{{ data.nights }}晚</span>
          </span>
          <span>
            <van-button round type="info" color="linear-gradient(to right, #65CD90, #1AC3A6)" style="width: 70px;height: 25px;font-size:12px">{{ data.orderStatusRemark }}</van-button>
          </span>
        </div>
        <div class="kh-ho" >
          地址:{{ data.departCityName }}{{ data.scdd }}
        </div>
        <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"/>
        <!--        入住时间-->
        <div class="kh-ho" style="display: flex;padding: 0px 9px 0px 9px;">
          <div>
            <span>{{ formatDate(data.departTime).monDay }}</span>
            <br>
            <span style="color: #BEBEDB;font-size: 12px">入住</span>
          </div>
          <div>
            <span>{{ formatDate(data.arriveDate).monDay }}</span>
            <br>
            <span style="color: #BEBEDB;font-size: 12px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;离店</span>
          </div>
        </div>
      </div>
    </van-row>
    <!--    飞机部分-->
    <div v-if="orderType == 11001 || orderType == 11003 || orderType == 11004 || orderType == 11006 || orderType == 11009 || orderType == 11011">
      <div class="Hotel">
        <div class="kh-ho">
          <span>
            <span class="business_icon_style" v-if="data.orderType == '11001'|| data.orderType == '11003' || data.orderType == '11004' || data.orderType == '11006'" style="width: 22px;height: 16px;">
              <img src="../../../images/home/cx1.png" style="width: 22px;height: 16px;">
            </span>&nbsp;
            <span class="business_icon_style" v-if="data.orderType == '11009'|| data.orderType == '11011'">
              <img src="../../../images/home/cx3.png" style="width: 17px;height: 16px">
            </span>&nbsp;
            <span>{{ data.flightNo }}·</span>
            <span v-if="data.orderType == '11001' || data.orderType == '11003' || data.orderType == '11004' || data.orderType == '11006'">{{ data.airlineName }}&nbsp;</span>
            <span>{{ formatDate(data.departDate).monDay2 }}·</span>
            <span>{{ formatDate(data.departDate).week }}</span>
          </span>
          <span>
            <van-button round type="info" color="linear-gradient(to right, #FCA09A, #F8648D)" style="width: 70px;height: 25px;font-size:12px">{{ data.orderStatusRemark }}</van-button>
          </span>
        </div>
        <div class="kh-ho" >
          <!-- {{data.departCityName}}&nbsp;-&nbsp;{{data.arriveCityName}} -->
          {{ data.voyageZh.split("-").join(" - ") }}
        </div>
        <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"/>
        
        <div class="kh-ho" style="display: flex;padding: 0px 9px 0px 9px;">
          <div style="width:50%;">
            <span>{{ data.departTime }}</span>
            <br>
            <span style="color: #BEBEDB;font-size: 12px">{{ data.departAirportName }}</span>
          </div>
          <div>
            <span style="color: red"
                  v-if="data.qxywbs == 1"
            >飞机延误</span>
          </div>
          <div style="width:50%;text-align:right;">
            <span>{{ data.arriveTime }}</span>
            <br>
            <span style="color: #BEBEDB;font-size: 12px">{{ data.arriveAirportName }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--    用车-->

    <div v-if="orderType==11018">
      <div class="Hotel">
        <div class="kh-ho">
          <span>
            <span class="business_icon_style">
              <img src="../../../images/home/cx4.png" style="width: 22px;height: 16px">
            </span>&nbsp;
            <span>{{ data.flightNo }}·</span>
            <span/>
            <span>·</span>
            <span/>
          </span>
          <span>
            <van-button round type="info" color="linear-gradient(to right, #36C2F0, #3B95F1)" style="width: 70px;height: 25px;font-size:12px">{{ data.orderStatusRemark }}</van-button>
          </span>
        </div>
        <div class="kh-ho" style="font-size: 12px">
          {{ data.scdd }}&nbsp;-&nbsp;{{ data.xcdd }}
        </div>
        <van-divider :style="{ color: '#fff', borderColor: '#fff', padding: '0 16px' }"/>
        <!--        入住时间-->
        <div class="kh-ho" style="display: flex;padding: 11px 11px;">
          <div>
            <span>用车时间</span>
          </div>
          <div>
            <span style="color: red"
                  v-if="data.qxywbs == 1"
            >飞机延误</span>
          </div>
          <div>
            <span>{{ data.departTime }}</span>
          </div>
        </div>
      </div>






      <van-row
        type="flex"
        align="center"
      >
        <van-col span="20">
          <span class="font16">
            {{ data.voyageZh }}&nbsp;-&nbsp;{{ data.productType | carproductType }}
          </span>
          <span class="gray">
            {{ data.departDate }}（{{ formatDate(data.departDate).week }}）
          </span>
        </van-col>
        <van-col
          v-if="findScope == 1"
          span="4"
          class="font16 font-bold light-green"
        >
          待出行
        </van-col>
      </van-row>

      <van-row
        type="flex"
        style="margin-top: 8px;"
      >
        <van-col span="10">
          <div class="font18 font-bold van-ellipsis">
            {{ data.scdd }}
          </div>
          <div
            class="gray"
            style="margin-top: 4px;"
          >
            {{ data.cabinName }}
          </div>
        </van-col>
        <van-col
          span="4"
          class="text-center"
        >
          <img
            width="36"
            :src="car_link"
          >
        </van-col>
        <van-col
          span="10"
          class="text-right"
        >
          <div class="font18 font-bold van-ellipsis">
            {{ data.xcdd }}
          </div>
        </van-col>
      </van-row>
    </div>


    <van-row
      gutter="10"
      v-if="orderType==11028 || orderType==11029 || orderType==11030 || orderType==11031"
    >

      <van-col span="6">
        <ld-icon
          class="main-color"
          size="56"
          :type="orderType | icon"
        />
      </van-col>
      <van-col span="13">
        <p class="font16 van-ellipsis">
          {{ data.departCityName }} - {{ data.voyageZh }}
        </p>
        <p
          class="font12 gray van-ellipsis"
          style="margin-top: 12px;"
        >
          <ld-icon type="iconjichang" />
          {{ data.scdd }}
        </p>
        <p
          class="font12 main-color van-ellipsis"
          style="margin-top: 8px;"
        >
          待使用
        </p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { Image,Button,Divider  } from 'vant'

import tk_link from '../images/tk-link.png'
import tr_link from '../images/tr-link.png'
import car_link from '../images/car-link.png'
import { formatDate } from '@/business/utils/dateUtil'
import mixin from 'Views/Home/allorder/components/orderMixin'

export default {
  name: 'SchedulePanel',
  mixins: [mixin],
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [Divider .name]: Divider ,
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    orderType: {
      type: [String, Number],
      default: 11001
    },
    findScope: {
      type: [String, Number],
      default: 1,
    }
  },
  data () {
    return {
      tk_link, tr_link, car_link,
    }
  },
  methods: {
    formatDate,
  }
}
</script>
<style lang="less" scoped>
.schedule-panel {
  color: #4d5059;
  border-radius: @border-radius-md;
  background-color: @color-background-white;
  //padding: 10px 16px;
  //padding-bottom: 24px;
}
.Hotel{
  height: 120px;
  border-radius: 5px;
  background: #EFEFF6;
}
.kh-ho{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px 0px 10px;
}
/deep/.van-divider{
  margin: 7px 0;
}
.business_icon_style{
  position: relative;
  width: 22px;
  height: 16px;
  display: inline-block;
  padding-right: 2px;
  padding-top: 0px;
  img{
    display: inline-block;
    position: absolute;
    top: 4px;
  }
}
</style>
